import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { OfferTeaser } from './components/sections/OfferTeaser';
import { Overview } from './components/sections/Overview';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Situations } from './components/sections/Situations';
import { Volumes } from './components/sections/Volumes';
import { Tools } from './components/sections/Tools';
import { Bonuses } from './components/sections/Bonuses';
import { OfferStack } from './components/sections/OfferStack';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
const FIRST_CTA_ID = 'first-cta';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="3mkhofzsx1e8o">
      <MetaPixel data-id="element-1" data-mp="3rbzpsoyupgu6" />
      <Hero ctaId={FIRST_CTA_ID} data-id="element-2" data-mp="3rdkkqfp2v1sk" />
      <main data-id="element-3" data-mp="3relv0hy9rk98">
        <OfferTeaser data-id="element-4" data-mp="5osn3wyp084" />
        <Overview data-id="element-5" data-mp="680tswt8a8y" />
        <BeforeAfter data-id="element-6" data-mp="4n6a3ahwrb3" />
        <Situations data-id="element-7" data-mp="56qxrrj5tst" />
        <Volumes data-id="element-8" data-mp="2zl3alhpbj03q" />
        <Tools data-id="element-9" data-mp="2zlle8zeb8glo" />
        <Bonuses data-id="element-10" data-mp="2zm4y4lnitf2c" />
        <OfferStack data-id="element-11" data-mp="2zmo4r67q0h12" />
        <Guarantee data-id="element-12" data-mp="2zn6b4vo3kbmp" />
        <Testimonials data-id="element-13" data-mp="33movnqc0akp0" />
        <Author data-id="element-14" data-mp="33lwxq8uxsavk" />
        <Faq data-id="element-15" data-mp="33nq921ghvj9w" />
        <FinalCta data-id="element-16" data-mp="33n6xr3lcnt4u" />
      </main>
      <Footer data-id="element-17" data-mp="33ohzyyz5cstu" />
      <FloatingCta anchorId={FIRST_CTA_ID} data-id="element-18" data-mp="38m1e7yvuh5ls" />
      <PurchasePopup data-id="element-19" data-mp="38k6u2msedhir" />
    </div>;
}